import styled from "styled-components";

/* 읽기 쉬운 시스템 폰트 */
const fontStack =
  'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Noto Sans", "Apple SD Gothic Neo", "Malgun Gothic", "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans", "맑은 고딕", sans-serif';

export const CardWrap = styled.div`
  --g-color: #4f46e5;

  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0; /* 바가 풀폭으로 붙도록 */
  display: grid;
  grid-template-rows: auto auto;
  row-gap: 8px;
  min-width: 0;
  font-family: ${fontStack};
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.02);
  overflow: hidden; /* 카드 바깥으로 절대 안 나가게 */

  /* 살짝 인터랙션: hover/keyboard focus 시 미묘하게 떠오름 */
  transition: box-shadow 160ms ease, transform 160ms ease,
    border-color 160ms ease;
  &:hover {
    box-shadow: 0 1px 0 rgba(15, 23, 42, 0.03), 0 8px 18px rgba(2, 6, 23, 0.06);
    transform: translateY(-1px);
    border-color: #dbe1ea;
  }
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.12),
      0 8px 18px rgba(2, 6, 23, 0.06);
    border-color: rgba(79, 70, 229, 0.35);
  }

  /* 반응형 컨테이너 쿼리 */
  container-type: inline-size;
`;

/* 상단 텍스트에만 패딩 */
export const ContentPad = styled.div`
  padding: 10px 12px 0 12px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: baseline;
  gap: 8px;
  min-width: 0;

  @media (max-width: 820px) {
    grid-template-columns: 1fr;
    gap: 6px;
    text-align: center;
    justify-items: center;
  }
`;

export const TitleWrap = styled.div`
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
`;

export const Dot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--g-color);
  flex: 0 0 auto;

  @media (max-width: 380px) {
    display: none;
  }
`;

export const Title = styled.div`
  min-width: 0;
  font-size: 12px;
  font-weight: 800;
  color: #0b1220;
  letter-spacing: 0.1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ValueText = styled.div`
  margin-left: auto; /* 와이드: 오른쪽 정렬 */
  font-size: 13px; /* 값은 살짝 크게 */
  line-height: 1.2;
  font-weight: 800;
  color: #0b1220;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;

  @media (max-width: 720px) {
    margin-left: 0;
    font-size: 12.5px;
    text-align: center;
  }
`;

export const Unit = styled.span`
  color: #475569;
  font-weight: 800;
  font-size: 12px;
`;

/* ===== 하단 진행바: 카드 폭 100%, 좌우 패딩 없음 ===== */
export const BarRow = styled.div`
  margin: 0;
  padding: 0;
`;

export const BarTrack = styled.div`
  position: relative;
  width: 100%;
  height: 4px;
  background: #eef2f6;
  border-top: 1px solid #e5e9ef;
  border-bottom: 1px solid #e5e9ef;
  border-radius: 999px;
  overflow: hidden;
`;

export const BarFill = styled.div<{ $color; $width }>`
  position: absolute;
  inset: 0;
  width: ${({ $width }) => `${$width}%`};
  border-radius: inherit;
  transition: width 220ms ease;
  will-change: width;

  /* 단색 */
  background: ${({ $color }) => $color};

  /* 하이라이트 스윕(호버/포커스 시만, 과하지 않게) */
  &::after {
    content: "";
    position: absolute;
    inset: -30% 0 -30% 0;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.22),
      transparent
    );
    transform: translateX(-120%);
    opacity: 0;
    pointer-events: none;
  }

  @media (prefers-reduced-motion: no-preference) {
    ${CardWrap}:hover &::after,
    ${CardWrap}:focus-visible &::after {
      opacity: 1;
      transform: translateX(120%);
      transition: transform 900ms ease, opacity 180ms ease;
    }
  }
`;
